// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  fromHero: __t.u64(),
  toHero: __t.u64(),
  giveItems: __t.array(__t.u64()),
  giveGold: __t.u32(),
  askItems: __t.array(__t.u64()),
  askGold: __t.u32(),
  note: __t.string(),
};
